import React from 'react';

import {
    useIsExporting
} from '../../../hooks/useExport.js';

function Empty({subject}) {
    const isExporting = useIsExporting();

    return (
        <div className='tlw-flex tlw-h-full tlw-grow tlw-items-center tlw-justify-center'>
            <div className='tlw-m-10 tlw-text-center'>
                <div className='tlw-text-lg tlw-leading-loose'>No {subject} found in this search.</div>
                {!isExporting &&
                    <div className='tlw-text-md'>Try broadening your search query or removing filters.</div>}
            </div>
        </div>
    );
}

export default Empty;
